import React from 'react'
import YoutubeEmbed from './VideoEmbed'

function Index() {
  return (
    <React.Fragment>
        <div className="videoSection">
        <div className="topBanner">
            <div className="container">
                <h1>Video</h1>
            </div>
        </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>
                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>
                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>
                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>
                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>
                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>

                    <div className="col-md-4 p-2 mb-2">
                        <div className="videoBox">
                        <YoutubeEmbed embedId="rokGy0huYEA" />
                        <p>Become the owner of your apartment on Main Raiwind Road Lahore in The SQ Shopping Mall. Prime Location on main raiwind and 3 years easy Installments. Booking Starts from as low as 9 Lac Only for Shop & 16 Lac for Apartment. Showrooms, Shops & 1, 2, 3 Bedroom Apartments.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
  )
}

export default Index